import React from "react";
import { useDispatch } from "react-redux";
import { getAuthor, getCategory } from "./Redux/PostReducer/Action";

function Post({ title, image, author_name, author_image, category, id }) {
  const dispatch = useDispatch();
  const handleAuthorName = (authurId) => {
    dispatch(getAuthor(authurId));
  };
  const handleCategoryName = (cate) => {
    dispatch(getCategory(cate));
  };
  return (
    <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
      <div className="flex-shrink-0">
        <img className="h-48 w-full object-cover" src={image} alt={title} />
      </div>

      <div className="flex-1 bg-white p-6 flex flex-col justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-indigo-600">
            {" "}
            {/* eslint-disable-next-line  */}
            <a
              onClick={() => handleCategoryName(category)}
              className="cursor-default inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 hover:text-green-500 text-indigo-800"
            >
              {category}
            </a>
          </p>
          <span className="block mt-1">
            <p className="text-xl font-semibold text-gray-900">{title}</p>
          </span>
        </div>
        <div className="mt-6 flex items-center">
          <div className="flex-shrink-0">
            <img
              onClick={() => handleAuthorName(author_name)}
              className="cursor-default h-10 w-10 rounded-full"
              src={author_image}
              alt=""
            />
          </div>
          <div className="ml-3">
            {/* eslint-disable-next-line  */}
            <a
              onClick={() => handleAuthorName(author_name)}
              className="cursor-default text-sm font-medium text-gray-900 hover:text-indigo-500 hover:underline"
            >
              {author_name}
            </a>
            <div className="flex space-x-1 text-sm text-gray-500">
              <time dateTime="2020-03-16">11 Jul, 2022 </time>
              <span aria-hidden="true"> &middot; </span>
              <span> 6 min read </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Post;
